module.exports = "/images/instagram-icon.svg";